// ─────────────────────────────────────────────────────────────────
// Middleware (Manhattan) Task Actions — URL query param `action=`
// ─────────────────────────────────────────────────────────────────

export const TASK_ACTIONS = {
  GET_ALL_TASK: 'get-all-task',
  ACCEPT_TASK: 'accept-task',
  START_TASK: 'start-task',
  COMPLETE_TASK: 'complete-task',
  CANCEL_TASK: 'cancel-task',
  GET_TASKS_SUMMARY: 'get-tasks-summary',
  GET_TRAILER_LIST: 'get-trailer-list-taskid',
  GET_LOCATION_LIST: 'get-location-list-taskid',
  MessageTypeGetLocationDetailList: 'getLocationList',
} as const;

// ─────────────────────────────────────────────────────────────────
// Task Action Types — request body `ActionType` field
// Matches Xamarin AppConstants: AcceptTaskActionType, StartTaskActionType, CancelTaskActionType
// ─────────────────────────────────────────────────────────────────

export const ACTION_TYPES = {
  ACCEPT: 'RESERVE',
  START: 'START',
  CANCEL: 'RELEASE',
} as const;

// ─────────────────────────────────────────────────────────────────
// Task Filter Strings (SQL-style filters sent in request body)
// ─────────────────────────────────────────────────────────────────

/** Strip all characters except alphanumeric and + to prevent injection */
function sanitizeUserId(userId: string): string {
  return userId.replace(/[^a-zA-Z0-9+]/g, '');
}

export const TASK_FILTER_STRINGS = {
  upcoming: 'IT.STATUS = 20',
  myTasks: (userId: string) =>
    `IT.STATUS IN (30) AND IT.ASSIGNED_USER_ID = '${sanitizeUserId(userId)}'`,
  completed: (userId: string) =>
    `IT.STATUS = 60 AND IT.ASSIGNED_USER_ID = '${sanitizeUserId(userId)}'`,
  inProgress: (userId: string) =>
    `IT.STATUS = 40 AND IT.ASSIGNED_USER_ID = '${sanitizeUserId(userId)}'`,
} as const;

export const taskcontants = {
  MoveTaskType: 'Move',
  Assigned_status: 'Assigned',
  InProgress_status: 'In Progress',
  Released_status: 'Released',
  LocationListType: 'All',
  MessageTypeGetLocationDetailList: 'getLocationList',
  TaskTypeMove: 'MOVE',
  SortOrderLocationDetailList: 'LOC_TYPE ASC, LOC_ZONE ASC, LOC_NAME',
  OriginatingSystem: 'YMSApp',
  RoutingCode: 'MA',
  MessageId: 'NA',
  Available: 'Open',
  TaskActionNew: 'CREATE',
  StopOnFirstError: 'Y',
  AuditTaskType: 'Audit',
  SuccessStatus: 'Success',
  YardSlotFilterItem: 'Yard',
  DockDoorFilterItem: 'Door',
  AllLabel: 'All',
  OtherTrailer: 'Other Trailer',
  TrailerQuestion: 'TRAILER',
  SelectedTrailerAlert: 'Selected trailer part of task',
  SelectedTrailerMessage: 'Selected trailer is already part of the current task',
  OtherTrailerAlert: 'Trailer present in the list',
  OtherTrailerMessage:
    'This trailer is already present in the list. Please select the trailer from the list.',
  messageTypeUpdateTasks: 'updateTasks',
  CompleteTaskStatus: 'Complete',
  OfflineStartTaskStatus: 'In Progress',
  AssignedTaskStatus: 'Assigned',
  PriorityCriticalValue: '10',
  PriorityHighValue: '20',
  PriorityCriticalValueInt: 10,
  PriorityHighValueInt: 20,
  ActionReleaseTask: 'update-task-actiontype',
  CancelledTaskStatus: 'Cancelled',
  CommonErrorMessage: 'Something went wrong. Please try again after some time.',
  TransmissionUser: 'nblyms',
  SortOrderPriorityDescTaskIdAsc: 'TASK_TYPE DESC, PRIORITY ASC',
  SortOrderPriorityStatusDescLastedUpdatedAsc: 'STATUS DESC, LAST_UPDATED_DTTM ASC',
  SortOrderPriorityStatusDescLastedUpdatedDesc: 'STATUS DESC, LAST_UPDATED_DTTM DESC',
  SortOrderPriorityLastUpdatedFirst: 'PRIORITY ASC, TASK_ID DESC',
  FilterUpcomingTask: 'IT.STATUS = 20',
  FilterCompletedTask: "IT.STATUS = 60 AND IT.ASSIGNED_USER_ID = '{0}'",
  FilterMyTaskTask: "IT.STATUS IN (30) AND IT.ASSIGNED_USER_ID = '{0}'",
  FilterOnGoingTask: "IT.STATUS = 40 AND IT.ASSIGNED_USER_ID = '{0}'",
  UserStatusEndYardWork: 'stop_yard_work',
  UserStatusLogout: 'logout',
  messageTypeGetTasks: 'GetTasks',
};

export const TaskSectionType = {
  MyTaskList: 'MyTaskList',
  UpcomingTaskList: 'UpcomingTaskList',
  CompletedTaskList: 'CompletedTaskList',
  OnGoingTask: 'OnGoingTask',
  AllTaskList: 'AllTaskList',
};
